import { Spacer } from "../atoms/Atoms"
import React from "react"
import { BodySmall } from "../atoms/Bodies"
import { H2, H3 } from "@carrotfertility/carotene"

const Section = ({ title, description, children }) => (
  <div>
    <H2>{title}</H2>
    {description ? (
      <div>
        <Spacer height={0.5} />
        {description}
        <Spacer height={1.5} />
      </div>
    ) : (
      <Spacer height={1.5} />
    )}
    {children}
  </div>
)

const TwoColumnRow = ({ left, right }) => (
  <div className="flex justify-between-ns flex-wrap nh25">
    <div className="w-50 mb1-ns flex-grow-1 ph25 min-w250px">{left}</div>
    <div className="w-50 flex-grow-1 ph25 min-w250px">{right}</div>
  </div>
)

const SingleShorty = ({ children }) => (
  <div className="flex flex-row justify-between-ns flex-wrap nh25">
    <div className="mb1 flex-grow-1 min-w250px ph25 w-50">{children}</div>
    <div className="w-50 min-w250px ph25" />
  </div>
)

const CheckboxSetting = ({ title, description, children }) => (
  <div className="flex flex-row justify-between-ns flex-wrap nh25">
    <div className="w-80 mb1-ns flex-grow-1 ph25">
      <H3 variant="primary">{title}</H3>
      <Spacer height={0.25} />
      <BodySmall>{description}</BodySmall>
    </div>
    <div className="flex w-8 flex-grow-1 ph25 justify-end">
      <Spacer width={1} />
      {children}
    </div>
  </div>
)

export { Section, TwoColumnRow, SingleShorty, CheckboxSetting }
